import { template as template_fdfbfeba5a1d4621857bfdb58f0871f0 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/html';
export default RouteTemplate(template_fdfbfeba5a1d4621857bfdb58f0871f0(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
